"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var COL = function COL(props) {
  var size = props.size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m254.617 65.001c-25.507 0-47.283 9.346-62.45 25.841-15.397 16.766-24.2 39.584-24.2 67.072 0 18.969 5.496 40.402 18.041 57.447 12.529 17.04 32.769 29.413 62.225 29.413.509 0 .994-.041 1.499-.05v53.593c0 19.827-4.344 23.901-22.585 23.901v12.771h82.333v-12.771c-16.946 0-23.249-2.442-23.249-22.54v-36.396h11.516s42.443 71.72 43.599 71.717c3.004-.01 50.687-.033 50.687-.033v-12.701s-9.582 1.573-18.491-6.194c-9.23-9.077-26.079-56.762-40-59.901 5.102-2.564 37.216-10.044 37.359-44.766-.143-37.539-34.906-49.703-69.678-49.703-7.388 0-20.858.546-34.549 1.358-17.378 1.088-26.288 1.903-39.526 2.988v12.768c18.67 0 22.584 4.344 22.584 24.714v24.291c-25.727-5.433-42.622-34.064-42.622-74.306 0-42.606 20.018-72.565 49.257-72.565 11.001 0 20.67 4.397 28.37 12.367 7.705 7.967 13.198 19.514 15.62 33.536h10.333l-1.968-57.456h-8.151c-.873 2.753-1.972 3.851-3.963 3.851-5.49 0-18.458-8.248-41.991-8.248l-.001.001zm31.613 109.74h10.644c21.073 0 32.166 14.122 32.166 35.573 0 27.98-11.292 40.204-42.808 39.659v-8.97c.826-.03 1.661-.08 2.466-.08 2.652 0 5.061.001 7.04.555 2.199.272 4.404.819 6.376 1.643l.671-1.92c6.369-18.69 11.653-39.033 13.408-54.708h-10.336c-5.254 14.087-11.812 24.635-19.624 31.675v-43.427h-.001z",
    fill: "#336"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m221.751 82.207s-44.642 17.495-44.684 74.38c-.056 58.279 43.036 69.287 43.036 69.287s-22.186-27.857-22.118-72.573c.08-48.145 23.765-71.095 23.765-71.095v.001zm55.64 93.111-18.762 1.3v145.563h18.762v-146.866.004zm48.122 1.278s12.378 7.906 12.362 35.862c0 27.69-12.93 35.478-12.93 35.478s34.978-7.206 34.884-35.798c-.094-32.456-34.317-35.542-34.317-35.542zm-.027 82.451s-2.64 1.044-6.27 2.074c-3.979 1.146-12.131 2.438-12.131 2.438 11.107 15.481 35.278 58.702 35.278 58.702l26.751.062s-5.581-4.439-13.378-20.051c-7.235-17.315-20.777-38.472-30.249-43.239z",
    fill: "#c4ced4"
  }));
};

COL.propTypes = {
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
COL.defaultProps = {
  size: '100'
};
var _default = COL;
exports["default"] = _default;